import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/denofdata.webp';
import screenshot_target from '../../../images/letterfunnel/pieterdegraaf.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Pieter de Graaf"
      firstname="Pieter"
      companyname="Den of Data"
      competition="RockingData en Inergy"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/pieterdegraaf.js